import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var tabbedContent = function tabbedContent() {
  Alpine.data('tabbedContent', function () {
    return {
      activeTabRef: '',
      activeTabIndex: 0,
      activeTabIsSet: false,
      init: function init() {
        this.tabButtons = this.$el.querySelectorAll('[x-bind="bindTabButton"]');
        // eslint-disable-next-line prefer-destructuring
        this.tabListElement = this.$el.querySelectorAll('[x-bind="bindTabList"]')[0];
        this.tabButtonsCount = this.tabButtons.length - 1;
        this.setActiveTabFromUrl();
      },
      setActiveTabFromUrl: function setActiveTabFromUrl() {
        var _this = this;
        var activeTabHash = window.location.hash.substring(1);
        if (activeTabHash) {
          this.tabButtons.forEach(function (button) {
            if (button.getAttribute('data-tab-ref') === activeTabHash) {
              _this.activeTabIndex = button.getAttribute('data-tab-index');
            }
          });
        }
        this.setActiveTab();
      },
      updateHistory: function updateHistory() {
        window.history.replaceState({}, document.title, "#".concat(this.activeTabRef));
        window.dispatchEvent(new Event('hashchange'));
      },
      setActiveTab: function setActiveTab() {
        if (this.activeTabIndex < 0) {
          this.activeTabIndex = this.tabButtonsCount;
        }
        if (this.activeTabIndex > this.tabButtonsCount) {
          this.activeTabIndex = 0;
        }
        this.activeTabRef = this.tabButtons[this.activeTabIndex].getAttribute('data-tab-ref');
        if (this.activeTabIsSet || window.location.hash.substring(1)) {
          this.tabButtons[this.activeTabIndex].focus();
          this.updateHistory();
        }
        if (!this.activeTabIsSet) this.activeTabIsSet = true;
      },
      tabListScroll: function tabListScroll() {
        var tabListClass = 'o-tabbed-content__tab-list';
        var maxScrollLeft = this.$el.scrollWidth - this.$el.clientWidth;
        if (this.$el.scrollLeft < 16) {
          this.$el.classList.add("".concat(tabListClass, "--scroll-start"));
        } else {
          this.$el.classList.remove("".concat(tabListClass, "--scroll-start"));
        }
        if (this.$el.scrollLeft > maxScrollLeft - 16) {
          this.$el.classList.add("".concat(tabListClass, "--scroll-end"));
        } else {
          this.$el.classList.remove("".concat(tabListClass, "--scroll-end"));
        }
      },
      bindArrowButton: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          if (this.$el.classList.contains('o-tabbed-content__arrow-right')) {
            this.tabListElement.scrollLeft += 100;
          } else {
            this.tabListElement.scrollLeft -= 100;
          }
        }
      },
      bindTabList: {
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.tabListScroll();
        },
        // eslint-disable-next-line func-names
        '@scroll': function scroll() {
          this.tabListScroll();
        },
        // eslint-disable-next-line func-names
        '@resize.window.debounce.500ms': function resizeWindowDebounce500ms() {
          this.tabListScroll();
        }
      },
      bindTabButton: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.activeTabIndex = this.$el.getAttribute('data-tab-index');
          this.setActiveTab();
        },
        // eslint-disable-next-line func-names
        '@keydown': function keydown(e) {
          // Active last tab on `End` keydown.
          if (e.keyCode === 35) {
            this.activeTabIndex = this.tabButtonsCount;
          }

          // Active first tab on `Home` keydown.
          if (e.keyCode === 36) {
            this.activeTabIndex = 0;
          }
        },
        // eslint-disable-next-line func-names
        '@keydown.right': function keydownRight() {
          this.activeTabIndex += 1;
          this.setActiveTab();
        },
        // eslint-disable-next-line func-names
        '@keydown.left': function keydownLeft() {
          this.activeTabIndex -= 1;
          this.setActiveTab();
        },
        // eslint-disable-next-line func-names
        ':aria-selected': function ariaSelected() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return this.activeTabRef === tabId;
        },
        // eslint-disable-next-line func-names
        ':tabindex': function tabindex() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return this.activeTabRef === tabId ? false : -1;
        }
      },
      bindTab: {
        // eslint-disable-next-line func-names
        'x-show': function xShow() {
          var tabId = this.$el.getAttribute('data-tab-ref');
          return tabId === this.activeTabRef;
        }
      }
    };
  });
};